import { useEffect } from "react";

export const useGridScrollToBottom = (dependency, containerId) => {
  useEffect(() => {
    const t = setTimeout(() => {
      const selector = `#${containerId} .MuiDataGrid-virtualScroller`;
      const el = document.querySelector(selector);
      if (el) el.scrollTop = el.scrollHeight;
    }, 50);
    return () => clearTimeout(t);
  }, [dependency, containerId]);
};
